var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('Slider'),_c('Main'),_c('page-setting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }